package ru.chm.gradereport.ui.screens.course

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import ru.chm.gradereport.model.CourseFormsSettingsDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.theme.GradeTheme

@Composable
internal fun CourseFormsSettingsDialog(
    settings: CourseFormsSettingsDto,
    saving: Boolean,
    onDismiss: () -> Unit,
    onSave: (formsBaseUrl: String, formsBearerToken: String?) -> Unit,
) {
    var baseUrl by remember(settings.formsBaseUrl) { mutableStateOf(settings.formsBaseUrl) }
    var bearerToken by remember { mutableStateOf("") }
    var clearBearer by remember { mutableStateOf(false) }
    val bearerConfigured = settings.formsBearerConfigured

    Dialog(onDismissRequest = onDismiss) {
        AppCard(
            modifier = Modifier
                .widthIn(min = 320.dp, max = 520.dp)
                .verticalScroll(rememberScrollState()),
        ) {
            Text(
                "Настройки форм курса",
                color = GradeTheme.colors.textPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 20.sp,
            )
            MutedText(
                "Шаблон ссылки на ответ формы. В POST ответов передаются поля формы — " +
                    "любой из них можно подставить в ссылку как {ключ}. Пример: " +
                    "https://forms.example/viewform?entry.1={formUuid}&uid={uid}. " +
                    "Без фигурных скобок работает по-старому: base + uuid.",
                modifier = Modifier.padding(top = 6.dp),
            )
            AppTextField(
                value = baseUrl,
                onValueChange = { baseUrl = it },
                label = "Базовый URL форм",
                modifier = Modifier.padding(top = 12.dp),
            )
            MutedText(
                if (bearerConfigured && !clearBearer) {
                    "Bearer-токен задан. Оставьте поле пустым, чтобы не менять; или введите новый."
                } else {
                    "Опционально: Bearer-токен для Authorization при POST ответов."
                },
                modifier = Modifier.padding(top = 12.dp),
            )
            AppTextField(
                value = bearerToken,
                onValueChange = {
                    bearerToken = it
                    if (it.isNotBlank()) clearBearer = false
                },
                label = "Bearer-токен для POST",
                modifier = Modifier.padding(top = 8.dp),
            )
            if (bearerConfigured) {
                SecondaryButton(
                    text = if (clearBearer) "Токен будет удалён при сохранении" else "Удалить Bearer-токен",
                    onClick = {
                        clearBearer = !clearBearer
                        if (clearBearer) bearerToken = ""
                    },
                    modifier = Modifier.padding(top = 8.dp).fillMaxWidth(),
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                SecondaryButton(
                    text = "Закрыть",
                    onClick = onDismiss,
                    modifier = Modifier.weight(1f),
                )
                PrimaryButton(
                    text = if (saving) "Сохранение..." else "Сохранить",
                    enabled = !saving,
                    onClick = {
                        val tokenUpdate: String? = when {
                            clearBearer -> ""
                            bearerToken.isNotBlank() -> bearerToken.trim()
                            else -> null
                        }
                        onSave(baseUrl.trim(), tokenUpdate)
                    },
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
